import { render, staticRenderFns } from "./ResponsiveCardListEntry.vue?vue&type=template&id=48dff7da&scoped=true&"
import script from "./ResponsiveCardListEntry.vue?vue&type=script&lang=ts&"
export * from "./ResponsiveCardListEntry.vue?vue&type=script&lang=ts&"
import style0 from "./ResponsiveCardListEntry.vue?vue&type=style&index=0&id=48dff7da&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48dff7da",
  null
  
)

export default component.exports